/**
 * The SMS provider refuses some countries (its geo-permissions), and the raw
 * error ("…blocked by Verify Geo-Permissions. BI is blocked for sms channel…")
 * means nothing to a visitor. Detect it so the sign-in screens can say so
 * plainly and offer email instead.
 */
export function isSmsCountryBlocked(err: unknown): boolean {
  const msg = String((err as { message?: string } | null)?.message ?? err ?? '');
  return /geo[- ]?permission|blocked for sms|permission to send an sms|not been enabled for the region|not (?:a )?supported (?:region|country)|unsupported (?:region|country)|country (?:is )?not supported|can(?:no|')t send (?:sms|text)/i.test(msg);
}

/** Shown after the form switches itself to email. */
export const SMS_BLOCKED_MESSAGE = 'We can\u2019t send text messages to numbers in your country yet, so we\u2019ve switched you to email. Enter your email address and we\u2019ll send your code there.';
